import React, { ChangeEvent, useEffect, useState, useRef } from "react";
import { TextField } from "@material-ui/core";
import MenuItem from "@material-ui/core/MenuItem";
import { ICatalogo } from "../../entities/catalogos/ICatalogo";
import useCommonApi from "../../api/useCommonApi";

interface ISelectControlProps {
    name: string;
    value: string | number | null;
    label: string;
    source: string; 
    dataSource?: ICatalogo[]; 
    variant?: any;
    onChange: (event, optionSelected: ICatalogo | undefined) => void;
}

const SelectControl = ({
    name,
    value,
    label,
    source,
    dataSource,
    onChange,
    variant,
}: ISelectControlProps) => {
    const [data, setData] = useState<ICatalogo[]>([]);
    const prevSource = useRef<string | null>(null);
    const isMounted = useRef(true);
    const apiSource = useCommonApi();

    useEffect(() => {
        isMounted.current = true;
        return () => {
            isMounted.current = false;
        };
    }, []);

    useEffect(() => {
        if (dataSource) {
            setData(dataSource);
            return;
        }

        if (source && source !== prevSource.current) {
            prevSource.current = source;

            const fetchData = async () => {
                try {
                    const result = await apiSource.obtenerAsync<ICatalogo[]>(source);
                    if (isMounted.current) setData(result);
                } catch (error) {
                    console.error("Error al obtener datos:", error);
                }
            };

            fetchData();
        }
    }, [source, dataSource, apiSource]);

    const handleChange = (event: ChangeEvent<{ name?: string; value: number | string }>) => {
        const id = event.target.value;
        const entitySelected = data.find((e) => e.id.toString() === id.toString());
        onChange(event, entitySelected);
    };

    return (
        <>
            {data.length > 0 && (
                <TextField
                    select
                    label={label}
                    value={value}
                    name={name}
                    variant={variant == null ? "filled" : variant}
                    fullWidth
                    onChange={handleChange}
                >
                    {data.map((option) => (
                        <MenuItem key={option.id} value={option.id}>
                            {option.nombre}
                        </MenuItem>
                    ))}
                </TextField>
            )}
        </>
    );
};

export default SelectControl;
